export default function setDeviceId() {
    let deviceId = "";
    let orgIdFromCookie = "";

    // Parse cookies
    const cookies = document.cookie.split(";").map(cookie => cookie.trim());

    // Find the "adtoken" and "remember-id-cookie" cookies
    cookies.forEach(cookie => {
        if (cookie.startsWith("adtoken=")) {
            deviceId = cookie.split("=")[1];
        }
        if (cookie.startsWith("remember-id-cookie=")) {
            orgIdFromCookie = cookie.split("=")[1];
        }
    });

    return { deviceId, orgIdFromCookie }; // Return both values
}